module.exports = __webpack_public_path__ + "static/img/samajuri (21).77a3814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (21).jpg
// module id = hU/L
// module chunks = 0